module.exports = __webpack_public_path__ + "static/media/logo_earthlovelife_colored.5bc99fbb.png";